import { render, staticRenderFns } from "./hue.vue?vue&type=template&id=4fbfebb6&"
import script from "./hue.vue?vue&type=script&lang=js&"
export * from "./hue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../rewards-admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports